import { Link } from "react-router-dom";
import { HeartHandshake } from "lucide-react";

export default function FloatingGetCare() {
  return (
    <Link
      to="/contact"
      data-testid="floating-get-care"
      className="hidden md:inline-flex fixed bottom-6 left-6 z-40 items-center gap-2 bg-brand-amber hover:bg-brand-amber-dark text-white font-semibold px-5 py-3.5 rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
    >
      <HeartHandshake className="w-5 h-5" />
      Get Care Now
    </Link>
  );
}
